<div fxLayout="column" fxLayoutAlign="center center">
  <div class="next-steps">
    <h1>Discipleship Path <strong>INVITING</strong> Next Steps</h1>
    <p>With respect to <strong>INVITING</strong>, below are considerations to enhance your spiritual walk in Christ.
      Before his ascension, <strong>INVITING</strong> was Jesus’ last command to His disciples. <a href="https://biblia.com/bible/esv/matthew/28/19-20" target="_blank">
        [Matthew 28:19-20]</a></p>
  </div>
  <hr class="divider" />
  <div class="exploring-christ">
    <h2>Exploring Christ</h2>
    <ul>
      <li>At times you consider <strong>INVITING</strong> people to church.<a href="https://biblia.com/bible/esv/psalms/95/1-2" target="_blank"> [Psalms 95:1-2]</a>
      </li>
    </ul>
  </div>
  <div class="growing-in-christ">
    <h2>Growing In Christ</h2>
    <ul>
      <li>
        Your awareness grows regarding Jesus' last command, making it your first concern.<a href="https://biblia.com/bible/esv/matthew/28/19-20" target="_blank"> [Matthew 28:19-20]</a>
      </li>
      <li>
        You discern when witnessing to a person has hit a barrier.<a href="https://biblia.com/bible/esv/matthew/7/6" target="_blank"> [Matthew 7:6]</a>
      </li>
    </ul>
  </div>
  <div class="close-to-christ">
    <h2>Close To Christ</h2>
    <ul>
      <li>
        You give forethought to how you will respond when someone asks you who Jesus is.<a href="https://biblia.com/bible/esv/1-peter/3/15" target="_blank"> [1 Peter 3:15]</a>
      </li>
      <li>
        You realize that you are only called to be a witness, and that salvation is a work of God.<a href="https://biblia.com/bible/esv/ephesians/2/8-9" target="_blank"> [Ephesians 2:8-9]</a>
      </li>
    </ul>
  </div>
  <div class="christ-centered">
    <h2>Christ-Centered</h2>
    <ul>
      <li>
        You seek opportunities to witness.<a href="https://biblia.com/bible/esv/jeremiah/1/7-8" target="_blank"> [Jeremiah 1:7-8]</a><a href="https://biblia.com/bible/esv/acts/8/27-28" target="_blank"> [Acts 8:27-28]</a>
      </li>
      <li>
        You pray the Lord opens your eyes on who to talk to, and what to say.<a href="https://biblia.com/bible/esv/colossians/4/2-6" target="_blank"> [Colossians 4:2-6]</a><a href="https://biblia.com/bible/esv/jeremiah/1/7-9" target="_blank"> [Jeremiah 1:7-9]</a>
      </li>
      <li>
        Your prayers include salvation for lost friends and family.<a href="https://biblia.com/bible/esv/romans/10/1" target="_blank"> [Romans 10:1]</a>
      </li>
    </ul>
  </div>
</div>